import React from 'react';
export var defaultTag = { start: '[', end: ']' };
export var defaultSuffix = { begin: '-begin', end: '-end' };
export var defaultSuppressLocaleHydrationWarnings = false;
export var LocalizationContext = React.createContext({
    locale: 'en-US',
    translations: {},
    tag: defaultTag,
    suffix: defaultSuffix,
    suppressLocaleHydrationWarnings: defaultSuppressLocaleHydrationWarnings,
});
//# sourceMappingURL=context.js.map